import SelectBuilder from '../builders/select-builder';
import { LanguageOption } from '../types/language-option';

export default class SelectBuilderFacade {
  static create(
    languages: LanguageOption[],
    onSelect: (language: string) => void,
    defaultValue?: string,
  ) {
    const builder = new SelectBuilder(languages);
    return builder
      .withDefaultValue(defaultValue || '')
      .withOnSelect(onSelect)
      .build();
  }
}
